import { DialogTitle, DialogContent, Typography, styled, DialogActions } from '@mui/material';

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingBottom: '0px',
  display: 'flex',
}));

export const StyledDialogTitleTypography = styled(Typography)(() => ({
  color: 'var(--kyocera-dark-grey)',
  fontFamily: 'Noto Sans',
  fontSize: '36px',
  fontWeight: 'bolder',
}));

const BaseDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const StyledDialogContent = BaseDialogContent;

export const StyledNotifDialogContent = styled(BaseDialogContent)({
  marginTop: '32px',
});

export const DialogActionsContainer = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: "var(--kyocera-dark-grey)",
  fontFamily: "Noto Sans",
  fontSize: "36px",
  fontWeight: "bolder",
}));

export const AppContainer = styled('div')(({ theme }) => ({
  "& button.MuiButton-root": {
    "&.Mui-disabled": {
      opacity: 0.5,
      backgroundColor: "var(--kyocera-bg-grey)",
      boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
      color: "var(--kyocera-text-grey)",
    },
    marginLeft: theme.spacing(2),
  },
}));
